import { useState, useEffect } from "react";
import api from "../Api";
import { useAuth } from "../context/authcontext";

/**
 * Custom hook to fetch the user's project role for a given project.
 * Always returns an object (never null) to avoid destructuring errors.
 *
 * @param {number|string|null} projectId
 * @returns {{ projectRole: string|null, loading: boolean, error: string|null }}
 */
export function useProjectRole(projectId) {
  const { auth } = useAuth();
  const [projectRole, setProjectRole] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (!projectId || !auth?.userId) {
      setProjectRole(null);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    api.get(`/projects/${projectId}/users/${auth.userId}`)
      .then(res => {
        if (isMounted) {
          setProjectRole(res.data?.project_role || null);
        }
      })
      .catch(() => {
        if (isMounted) {
          setProjectRole(null);
          setError("Kan projectrol niet ophalen.");
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => { isMounted = false; };
  }, [projectId, auth?.userId]);

  return { projectRole, loading, error };
}

